import { render, staticRenderFns } from "./potatoSummary.vue?vue&type=template&id=7a9ebd36&scoped=true&"
import script from "./potatoSummary.vue?vue&type=script&lang=js&"
export * from "./potatoSummary.vue?vue&type=script&lang=js&"
import style0 from "./potatoSummary.vue?vue&type=style&index=0&id=7a9ebd36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9ebd36",
  null
  
)

export default component.exports